export function sendConversionUrl() {
    var pageURL = window.location.href;
    var inputElements = document.querySelectorAll('.hs_conversion_page_url > div input');
    document.attempts = 0;
    document.maxAttempts = 20;

    if (inputElements.length > 0) {
                for(let i=0; i < inputElements.length; i++) {
                    inputElements[i].value = pageURL;
                }

        console.log(inputElements.length + " Input field found and value set on first try" + pageURL);
    } else {
        var interval = setInterval(function() {
            var inputElements = document.querySelectorAll('.hs_conversion_page_url > div input');
            document.attempts++;
            if (inputElements.length > 0) {
                clearInterval(interval);
                for(let i=0; i < inputElements.length; i++) {
                    inputElements[i].value = pageURL;
                }

                console.log(inputElements.length + " Input field(s) found and value set mang" + pageURL);
            } else if (document.attempts >= document.maxAttempts) {
                clearInterval(interval);
                console.log("Input field not found after 20 attempts");
            } else {
              console.log(document.attempts + ' attempts');
            }
        }, 1000); // Check every 100 milliseconds
    }
}